// extracted by mini-css-extract-plugin
module.exports = {"BaseSectionWithImage":"BaseSectionWithImage-module__BaseSectionWithImage___1U9kb","title":"BaseSectionWithImage-module__title___D-VUv"};